import React from 'react'
import axios from '../../API/axios';
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo2 from "../../assets/images/logo2.png";
import logo from "../../assets/images/logo.png";
import useLocalStorage from 'use-local-storage';

const VerifyAccount = () => {
    const navigate = useNavigate();
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    const query = useQuery();
    const userID = query.get("UserID");
    const token = query.get("Token");
    console.log("userID", userID, token);

    const Confirm = async (e) => {
        try {
            await axios
                .post(
                    `Auth/ConfirmEmail?UserID=${userID}&Token=${token}`, {}
                )
                .then((res) => {
                    console.log("res", res);
                    toast.success(res.data.message);
                    navigate('/Login');
                });
        } catch (error) {
            toast.error(error.response.data.message);
        }
    };
    return (
        <div>
            <header>
                <div className="main-logo">
                    <div className="header-ct-left d-flex justify-content-center mt-3 setnewpassword">
                        {isDark ? (
                            <div id="logo" className="logo">
                                <Link to="/Home">
                                    <img
                                        className="site-logo"
                                        id="trans-logo"
                                        src={logo2}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                        ) : (
                            <div id="logo" className="logo">
                                <Link to="/Home">
                                    <img
                                        className="site-logo"
                                        id="trans-logo"
                                        src={logo}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </header>
            <div className='d-flex justify-content-center align-items-center mt-5' style={{ height: '70vh' }}>
                <div className="khojPrimaryBtn ms-3 text-center" style={{ width: '200px' }}>
                    <a
                        onClick={Confirm}
                        style={{ cursor: 'pointer' }}
                    >
                        Confirm Account
                    </a>
                </div>
            </div>
        </div>
    )
}

export default VerifyAccount